document.querySelectorAll('.cg_pg_se_btn').forEach(cgpg_bt => {
  cgpg_bt.addEventListener('click', event => {
    const clcls = event.currentTarget.className;
    console.log(clcls);
    var nw_int = parseInt(document.querySelectorAll(".cg_step_main input[name='cg_step_cnt_inp']:checked")[0].getAttribute("id").replace("cg_step_cnt_inp_",""));
    document.querySelectorAll(".cg_step_main #cg_step_cnt_inp_" + nw_int).checked = false;
    if(clcls == "cg_pg_se_btn cgpg_prv"){
        document.querySelectorAll(".cg_step_main #cg_step_cnt_inp_" + (nw_int - 1))[0].checked = true;
    }else if(clcls == "cg_pg_se_btn cgpg_nxt"){
        document.querySelectorAll(".cg_step_main #cg_step_cnt_inp_" + (nw_int + 1))[0].checked = true;
    };
  });
});